/*eslint @typescript-eslint/no-unused-vars: 'off'*/
import { ArrowBackIosNew } from '@mui/icons-material';
import { Divider, Toolbar } from '@mui/material';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Link, { LinkProps } from '@mui/material/Link';
import { ListItemProps } from '@mui/material/ListItem';
import Snackbar from '@mui/material/Snackbar';
import useTheme from '@mui/material/styles/useTheme';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, useMemo, useState } from 'react';
import { Link as RouterLink, Outlet, useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { getCommonTagId } from './components/AmenityChoices';
import { PageFooter } from './components/page-footer';
import { ProfileData } from './profiles';
import styles from './styles/Home.module.css';
import { AssetInterface, OrganizationStyling } from './types';

export interface ProfOutletContext extends ProfileData {
  profileId: string;
  logoAsset?: AssetInterface;
  logoTitle?: string;
  colorPrimary?: string;
  fontBody?: string;
  fontHeader?: string;
  isXSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  notify: string;
  setNotify: ReturnType<typeof useState<string>>[ 1 ];
}

interface ListItemLinkProps extends ListItemProps {
  to: string;
  open?: boolean;
}

const breadcrumbNameMap: { [ key: string ]: string } = {
  'recipients': 'Authorized Recipients',
  'unsubscribe': 'Unsubscribe',
};

const breadcrumbLabel = ( key: string ): string => {
  return key;
}


interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

function LinkRouter( props: LinkRouterProps ) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Link {...props} component={RouterLink as any} />;
}


export const Prof: FC = () => {
  const data = useLoaderData() as ProfileData;
  const location = useLocation();
  const pathnames = location.pathname.split( '/' ).filter( ( x ) => x ).slice( 3 );
  const basePathnames = location.pathname.split( '/' ).filter( ( x ) => x ).slice( 0, 3 );
  const navigate = useNavigate();
  const theme = useTheme();
  const isXSmall = useMediaQuery( theme.breakpoints.down( 'sm' ) );
  const isSmall = useMediaQuery( theme.breakpoints.down( 'md' ) );
  const isMedium = useMediaQuery( theme.breakpoints.down( 'lg' ) );
  const [ notify, setNotify ] = useState( '' );

  const { profileId, recipient, recipients, organization, assets, countryCode } = data;

  const { logoAsset, logoTitle, colorPrimary, fontBody, fontHeader } = useMemo( () => {
    if( !organization ) return {};
    // const { amenityTags } = organization;
    const { iconStyle = 'default', amenityLayout, colorPrimary, colorSecondary, fontBody, fontHeader } = ( organization || {} ) as unknown as OrganizationStyling;
    const iconProps = {
      // htmlColor: [ 'default', 'primary', 'secondary' ].includes( iconStyle ) ? undefined : iconStyle,
      '& svg': {
        color: [ 'primary', 'secondary' ].includes( iconStyle )
          ? ( iconStyle == 'primary' ? colorPrimary : colorSecondary )
          : 'inherit',
        fontSize: '2.25rem', // 'large',
      }
    };
    const logoAsset = ( assets ).find( asset => ( asset.tags || [] ).includes( getCommonTagId( 'square' ) ) );
    const logoTitle = [ organization.name, logoAsset?.subject || 'logo' ].join( ' ' );
    return { logoAsset, logoTitle, iconProps, amenityLayout, colorPrimary, colorSecondary, fontBody, fontHeader };
  }, [ assets, organization ] );

  const TopSection: FC = () => {
    return (
      <>
        <Grid item container direction="column"
          sx={{
            // padding: { xs: '0 -2em', md: 'inherit' },
            // width: { xs: '120%', md: '100%' },
          }}
        >
          <Link
            href='/'
            sx={{
              margin: { xs: '0 -2.5em', md: 'inherit' },
              width: { xs: '120%', md: '100%' },
              textDecorationLine: 'none',
            }}
          >
            <Typography variant='h1'
              align={isXSmall ? 'center' : 'left'}
              sx={{
                fontFamily: fontHeader, // !isXSmall ? fontHeader : undefined,
                backgroundColor: colorPrimary,
                color: 'white',
                width: '100%',
                padding: { xs: '0.5rem 3.0rem', md: '0.5rem 1.0rem' },
                fontWeight: 'bold', //'600',
                fontSize: 'large',
                fontSmooth: 'always',
              }}
            >
              AIC Patient Concierge &trade;
              { /* transparent button used to match height of Location header bar */}
              <IconButton sx={{ color: 'transparent' }}>
                <ArrowBackIosNew />
              </IconButton>
            </Typography>
          </Link>
        </Grid>

        <Link
          key='name'
          href='/' sx={{ width: '100%', textDecorationLine: 'none' }}>
          <Typography variant='h1'
            align={ /* isXSmall ? 'center' : */ 'left'}
            style={{
              fontFamily: !isXSmall ? fontHeader : undefined,
              // backgroundColor: colorPrimary,
              color: colorPrimary, // 'white',
              width: '100%',
              padding: '0.5rem 0',
              fontWeight: 'bold', //'600',
              fontSize: 'xx-large',
              fontSmooth: 'always',
            }}
          >
            {organization?.name}
          </Typography>
        </Link>
      </>
    );
  }

  const SimpleSnackbar: FC<{ open: boolean, onClose: () => void, message: string }> = ( props ) => {
    const { open, onClose, message } = props;

    return (
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity='success'
          variant='filled'
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }



  return (
    <Box
      id='profile'
      sx={{
        padding: { xs: 0, md: '0 1.5rem' },
        maxWidth: '960px',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontSize: { xs: '1rem', md: '1.2rem' },
        backgroundColor: '#f9fafb',
        fontFamily: fontBody,

      }}>

      <main className={styles.main}
        style={{

        }}
      >

        <SimpleSnackbar
          open={!!notify}
          onClose={() => { setNotify( '' ) }}
          message={notify}
        />
        <TopSection />
        <Divider />

        <Toolbar sx={{ width: '100%' }} >
          <Breadcrumbs aria-label="breadcrumb"
            separator="|"
          >
            <LinkRouter underline="hover" color="inherit" to={`/${ basePathnames.join( '/' ) }`}>
              My Profile
            </LinkRouter>
            {pathnames.map( ( value, index ) => {
              const last = index === pathnames.length - 1;
              const to = `/${ [ ...basePathnames, ...pathnames.slice( 0, index + 1 ) ].join( '/' ) }`;
              const leaf = pathnames.slice( -1 )[ 0 ];

              return last
                ? (
                  <Typography color="text.primary" key={to}>
                    {breadcrumbNameMap[ leaf ] || to}
                  </Typography>
                )
                : (
                  <LinkRouter underline="hover" color="inherit" to={to} key={to}>
                    {breadcrumbNameMap[ leaf ] || to}
                  </LinkRouter>
                );
            } )}
          </Breadcrumbs>
        </Toolbar>

        <Box
          sx={{
            minHeight: 680,
            // border: '1px blue solid',
            width: '100%',
          }}
        >
          <Outlet context={{
            profileId, recipient, recipients, organization, assets, countryCode,
            logoAsset, logoTitle, colorPrimary, fontBody, fontHeader,
            isXSmall, isSmall, isMedium,
            notify, setNotify,

          }} />
        </Box>
        <PageFooter />
      </main>
    </Box >
  );
}

